import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { DQOIErrorBus } from '@app/cp/shared/models/DQOIError';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { DispatchKudosBus } from '@app/cp/shared/models/DispatchKudosBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'dispatch-kudos',
    templateUrl: './dispatch-kudos.component.html',
    styleUrls: ['./dispatch-kudos.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchKudosComponent extends BaseGridEditLineComponent<DispatchKudosBus, null, DispatchesService>  {
    dispKudosCatFC: MSFilterClass = new MSFilterClass('categoryName');
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "DispatchKudosBus";
        this.appCode = "DispatchKudos";
        this.appName = "Dispatch Kudos";
        this.callSaveIndividualInsteadOfSave = true;
        //necessary for grid displays that dont search
        this.disableCpSearchDialog();
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchKudosId': new UntypedFormControl(),
            'dispatchKudosCatId': new UntypedFormControl('', Validators.required),
            'personId': new UntypedFormControl('', Validators.required), 
            'comments': new UntypedFormControl(), 
            'insertDt': new UntypedFormControl(),
            'insertUser': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUser': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'categoryName': new UntypedFormControl(), 
            'personName': new UntypedFormControl(), 
            'insertUserName': new UntypedFormControl() 
        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchKudosId: this.selectedData.dispatchKudosId,
            dispatchKudosCatId: this.selectedData.dispatchKudosCatId,
            personId: this.selectedData.personId,
            comments: this.selectedData.comments,
            insertDt: this.selectedData.insertDt,
            insertUser: this.selectedData.insertUser,
            updateDt: this.selectedData.updateDt,
            updateUser: this.selectedData.updateUser,
            dispatchId: this.selectedData.dispatchId,
            categoryName: this.selectedData.categoryName,
            personName: this.selectedData.personName,
            insertUserName: this.selectedData.insertUserName
        });
    }
    setFromReferenceData(data: DispatchKudosBus) {
        data.insertUserName = this.personFromUserId(data.insertUser).description;
        if (data.personId) { data.personName = this.person(data.personId).description; }
        else { data.personName = "" }
        if (data.dispatchKudosCatId) { data.categoryName = this.referenceData.getDispatchKudosCatDesc(data.dispatchKudosCatId); }
        else { data.categoryName = "" }
        return data;
    }

    getChangedObject(data: DispatchKudosBus) {
        let busObj: DispatchKudosBus = new DispatchKudosBus(data);
        busObj = this.setFromReferenceData(busObj);
        busObj.setBeforeSave();
        return busObj;
    }
    //save(data: DispatchKudosBus) {
    //    let busObj: DispatchKudosBus = this.getChangedObject(data);      
    //    this.svc_data.saveDispatchKudos(busObj).subscribe((info: BaseMessageInfo) => {
    //        if (!info.saveError) {
    //            let dataObj: DispatchKudosBus = new DispatchKudosBus(info.primaryReturn);
    //            dataObj = this.setFromReferenceData(dataObj);
    //            this.removeLocalAdded();
    //            //dataObj.isAdded = this.isNew;
    //            this.saveSuccess(dataObj);
    //        }
    //        else {
    //            this.saveError(info.primaryReturn as DispatchKudosBus, info.message);
    //        }
    //    });
    //}
    saveIndividual(dataObj: DispatchKudosBus): Promise<BaseMessageInfo> {
        let busObj: DispatchKudosBus = this.getChangedObject(dataObj);
        var isAdded = busObj.isAdded;
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.saveDispatchKudos(busObj).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let newDataObj: DispatchKudosBus = new DispatchKudosBus(info.primaryReturn);
                    newDataObj = this.setFromReferenceData(newDataObj);
                    retInfo.primaryReturn = newDataObj;
                    this.notify(this.appCode + " Saved Successfully!");                }
                else {
                    this.saveError(info.primaryReturn as DispatchKudosBus, info.message);
                }
                resolve(retInfo);
            });
        });
    }
    deleteIndividual(data: DispatchKudosBus) {
        if (data.hasId) {
            this.svc_data.deleteDispatchKudos(data.dispatchKudosId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
}
